module.exports = __webpack_public_path__ + "9f81c9a43a9c78237086306ebdaa757b.png";